import React from 'react'

const Workflow = () => {
  return (
    <>
         <div class="container-fluid bgimg2 py-5">
        <div class="container  pt-5 pb-3">
            <h1 class="display-4 text-uppercase text-center mb-5">My Workflow Process</h1>
            
                <div class="steps">
                    <div class="step">
                    
                        <p class="text-green "><b class="text-warning">1.Requirements- </b>
                            'll make sure I have everything needed to complete your project.​</p>
                    </div>
                    <br/>
                    <div class="step">
                    
                        <p class="text-green "><b class="text-warning">2.Development- </b>
                            I'll develop the project and deliver a working product for your review.​</p>
                    
                    </div>
                    <div class="step">
                    
                        <p class="text-green "><b class="text-warning">3.Modifications- </b>
                            I'll modify assets or content based on your feedback.​</p>
                    
                    </div>
                    <div class="step">
                    
                        <p class="text-green "><b class="text-warning">4.Delivery- </b>
                            I'll send you the final delivery for review and feedback.​</p>
                    
                    </div>
                    
                    </div>
                
             
            
        </div>
    </div>
    
    </>
  )
}

export default Workflow